import { render } from "./FilterContainer.vue?vue&type=template&id=768805da"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FilterContainer.vue"]])

export default __exports__